import styled, {css} from 'styled-components';

import {getBlackoutColor, getRem, ms, square} from '../../../../styles';
import {LottieView} from '../../../../uikit/LottieView';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {envManager} from '../../../../utils/env';

export const Wrapper = styled(View)`
  flex: 1;
  align-items: center;
  flex-direction: column;
  padding-inline: ${ms(20)};
`;

export const Container = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${ms(12)};
  color: #fff;
  text-align: center;
  max-width: ${ms(410)};
`;

export const Icon = styled(LottieView)<{isShortUI: boolean}>`
  ${square(160)};
  align-self: center;

  ${p =>
    p.isShortUI &&
    css`
      ${square(100)};
    `};
`;

const TextBase = styled(Text)`
  font-size: ${getRem(18)};
  line-height: ${getRem(26)};
  letter-spacing: ${getRem(-0.468)};
  color: #fff;
  text-align: center;
`;

export const TitleContainer = styled(View)`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

export const Title = styled(TextBase).attrs({weight: 'bold'})<{
  isSmallUI: boolean;
}>`
  font-size: ${ms(24)};
  line-height: ${ms(32)};

  ${p =>
    p.isSmallUI &&
    css`
      font-size: ${getRem(20)};
      line-height: ${getRem(26)};
    `};
`;

export const Subtitle = styled(TextBase)<{isSmallUI: boolean}>`
  padding-inline: ${ms(20)};

  ${p =>
    p.isSmallUI &&
    css`
      font-size: ${getRem(14)};
      line-height: ${getRem(22)};
    `};
`;

export const DidYouKnow = styled(TextBase).attrs({weight: 'semibold'})`
  font-size: ${getRem(14)};
  line-height: ${getRem(20)};
  margin-block-start: ${ms(12)};
`;

export const Fact = styled(View)`
  padding-block: ${ms(22)};
  padding-inline: ${ms(30)};
  justify-content: center;
  align-items: center;
  border-radius: ${ms(17)};
  background-color: rgba(255, 255, 255, 0.3);
  max-width: ${ms(350)};

  ${envManager.isCore &&
  css`
    background-color: ${getBlackoutColor('global2', 'strong')};
  `}
`;

export const FactText = styled(TextBase)`
  font-size: ${getRem(14)};
  line-height: ${getRem(20)};
`;
